import { Change } from '@ritabygglov/core';
import { Command } from './Command';

export class CompositeCommand implements Command {
  isEphemeral = false;

  constructor(private commands: Command[]) {}

  execute(): Change[] {
    return this.commands.flatMap((command) => command.execute());
  }

  undo(): Change[] {
    return this.commands.flatMap((command) => command.undo());
  }
}
